import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

import { useFpsStore } from '../store/useFpsStore';
import { IFpsService } from './IFpsService';
import { FpsServiceImpl } from './FpsServiceImpl';
import { FpsServiceExceptionDecorator } from './FpsServiceExceptionDecorator';

export class FpsServiceFactory {
  private static instance: FpsServiceFactory | null = null;
  private fpsStore: typeof useFpsStore;
  private fddmStore: typeof useFloorplanDesignStore;

  public static initialize(
    fpsStore: typeof useFpsStore,
    fddmStore: typeof useFloorplanDesignStore,
  ) {
    FpsServiceFactory.instance = new FpsServiceFactory(fpsStore, fddmStore);
  }

  public static getInstance() {
    if (FpsServiceFactory.instance === null) {
      throw new Error(
        'FpsServiceFactory not yet initialized. Call FpsServiceFactory.initialize() first.',
      );
    }
    return FpsServiceFactory.instance;
  }

  private constructor(fpsStore: typeof useFpsStore, fddmStore: typeof useFloorplanDesignStore) {
    this.fpsStore = fpsStore;
    this.fddmStore = fddmStore;
  }

  public createFpsService(): IFpsService {
    let result: IFpsService = this.makeFpsService();

    result = new FpsServiceExceptionDecorator(result);
    result = new FpsServiceExceptionDecorator(result);

    return result;
  }

  private makeFpsService(): IFpsService {
    return new FpsServiceImpl(this.fpsStore, this.fddmStore);
  }
}
